import * as React from 'react';
import s from './search-result-header.scss';
import { SearchResultHeaderEmptyState } from './search-result-header-empty-state';
import { SearchResultHeaderContent } from './search-result-header-content';
import { composer } from '../../../component-decorators/composer';
import { TerminatorContainer } from '../terminator';
import { getTerminatorSuggestion } from '../terminator/terminator-data';
import { Text, Heading } from 'wix-style-react';
// export const dtoToSearchResultHeaderPropIsResult = (
//   solutionsBaseInfoDto: ISolutionsBaseInfoDTO,
// ): boolean => {
//   return Object.keys(solutionsBaseInfoDto.suggestions).length > 0;
// };
export var SearchResultHeader = composer()
    .withTranslation()
    .withExperiments()
    .compose(function (_a) {
    var t = _a.t, experiments = _a.experiments, query = _a.query, isResult = _a.isResult, numOfResults = _a.numOfResults;
    var hasTerminatorSuggestion = query
        ? getTerminatorSuggestion(query, experiments) !== null
        : false;
    return (React.createElement("div", { "data-testid": 'search-result-header', className: s.backgroundSearchResultPage },
        isResult || hasTerminatorSuggestion ? (React.createElement(SearchResultHeaderContent, { query: query })) : (React.createElement(SearchResultHeaderEmptyState, { query: query })),
        React.createElement(TerminatorContainer, { term: query }),
        isResult ? (React.createElement(Text, { className: s.sortApps, size: "medium", weight: "thin", dataHook: "search-result-header-num-of-results", tagName: "div" }, t('searchResultHeader.numberOfApps', {
            numOfResults: numOfResults,
        }))) : (React.createElement("div", { className: s.recommended },
            React.createElement(Heading, { appearance: "H2", dataHook: "search-result-header-recommended" }, t('searchResultHeader.recommendedApps'))))));
});
//# sourceMappingURL=search-result-header.js.map